<template>
	<el-dialog title="手机号绑定" :append-to-body="true" :visible.sync="centerDialogVisible" width="60%" center
		@close="onClose">
		<div class="dialog-content">
			<p>☆请填写微信绑定的手机号码，便于与微信小程序端共用账号数据</p>
			<el-form :model="form">
				<el-form-item label="手机号码" label-width="78px">
					<el-input v-model="form.tell" type="tel" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="onConfirm">确 定</el-button>
			</div>
		</div>
	</el-dialog>
</template>
<script>
	export default {
		name: "tellBindDialog",
		components: {},
		computed: {},
		data() {
			return {
				centerDialogVisible: false,
				form: {
					tell: ''
				},
			};
		},
		methods: {
			async onOpen(id) {
				console.log("onOpen ===> ");
				this.centerDialogVisible = true;
			},
			onClose() {
				this.centerDialogVisible = false;
				if (this.checkInterval) clearInterval(this.checkInterval);
			},
			async onConfirm() {
				console.log("this.form ===> ", this.form);
				if (!this.form.tell) return;
				const infoRes = await this.$zkHttp.user$profile({
					user_id: this.$store.state.auth.user_id,
					mobile: this.form.tell
				});
				console.log("infoRes ===> ", infoRes);
				if (infoRes) {
					this.onClose();
					this.$message({
						showClose: true,
						message: '绑定成功，请继续操作！',
						duration: 3000,
						type: "success", // message type: success/warning/info/error
					});
					this.$emit('onSuccess');
				}
			},
		}
	}
</script>
<style scoped lang="scss">
	* {
		margin: 0;
		padding: 0;
	}

	::v-deep .el-dialog {
		min-width: 720px;
		max-width: 800px;

		.el-dialog__header .el-dialog__title {
			font-weight: bold;
			letter-spacing: 4px;
		}

		.dialog-content {
			width: 100%;
			display: flex;
			flex-direction: column;

			.el-form {
				margin-top: 20px;
				width: 100%;
			}

			.dialog-footer {
				margin-top: 30px;
				width: 100%;

				.el-button {
					margin: 0 25%;
					width: 50%;
					display: inline-block;
					line-height: 1;
					white-space: nowrap;
					cursor: pointer;
					background-color: #F56C6C;
					border: 1px solid #F56C6C;
					border-radius: 10px;
					color: #606266;
					-webkit-appearance: none;
					text-align: center;
					box-sizing: border-box;
					outline: 0;
					transition: .1s;
					font-weight: 500;
					padding: 12px 20px;
					font-size: 14px;
					color: #FFF;
				}
			}
		}
	}
</style>